import axiosInstance from './axiosInstance';

export interface ApiKey {
  id: string;
  name: string;
  key?: string; // 只在创建时返回
  keyPrefix: string;
  allowedDomains: string[];
  isActive: boolean;
  createdAt?: string;
  lastUsedAt?: string;
  createdBy?: string;
}

export interface ApiKeyListResponse {
  apiKeys: ApiKey[];
  total: number;
}

export class ApiKeyApi {
  static async getApiKeys(skip: number = 0, limit: number = 20): Promise<ApiKeyListResponse> {
    const response = await axiosInstance.get('/cms/v1/apikey', {
      params: { skip, limit }
    });
    return response.data.data;
  }

  static async getApiKey(id: string): Promise<ApiKey> {
    const response = await axiosInstance.get(`/cms/v1/apikey/${id}`);
    return response.data.data;
  }

  static async createApiKey(name: string, allowedDomains: string[] = []): Promise<ApiKey> {
    const response = await axiosInstance.post('/cms/v1/apikey', {
      name,
      allowedDomains
    });
    return response.data.data;
  }

  static async updateApiKey(
    id: string,
    name?: string,
    allowedDomains?: string[],
    isActive?: boolean
  ): Promise<ApiKey> {
    const updateData: any = {};
    if (name !== undefined) updateData.name = name;
    if (allowedDomains !== undefined) updateData.allowedDomains = allowedDomains;
    if (isActive !== undefined) updateData.isActive = isActive;

    const response = await axiosInstance.put(`/cms/v1/apikey/${id}`, updateData);
    return response.data.data;
  }

  static async deleteApiKey(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/apikey/${id}`);
  }
}
